export const QUESTIONNAIRE_SUCCESS_BG_COLOR = "moveon.success";
export const QUESTIONNAIRE_CHECKMARK_COLOR = "white";
export const QUESTIONNAIRE_SHOW_CHECKMARK = true;
export const QUESTIONNAIRE_CHECKMARK_SIZE = "md" as const;
export const QUESTIONNAIRE_CHECKMARK_POSITION: "top-right" | "center" =
  "top-right";
export const QUESTIONNAIRE_HOLD_DURATION_MS = 200;
export const QUESTIONNAIRE_ANIMATION_DURATION_MS = 200;
export const QUESTIONNAIRE_SCALE_TARGET = 0.5;
export const QUESTIONNAIRE_OPACITY_TARGET = 0;
export const QUESTIONNAIRE_EASING_FUNCTION = "ease-in-out" as const;
